const e = "_textBox_30vgn_1", s = "_necessary_30vgn_38", t = {
  textBox: e,
  necessary: s
};
export {
  t as default,
  s as necessary,
  e as textBox
};
//# sourceMappingURL=text-box.module.less.js.map
